"use client";

import { c as _c } from "react/compiler-runtime";
import TimeAgo from "react-timeago";
import { makeIntlFormatter } from "react-timeago/defaultFormatter";
const intlFormatter = makeIntlFormatter({
  locale: "en",
  style: "long",
  numeric: "auto"
});
const RelativeTime = t0 => {
  const $ = _c(4);
  let rest;
  if ($[0] !== t0) {
    ({
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = rest;
  } else {
    rest = $[1];
  }
  let t1;
  if ($[2] !== rest) {
    t1 = <span suppressHydrationWarning={true}><TimeAgo formatter={intlFormatter} {...rest} /></span>;
    $[2] = rest;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
export { RelativeTime };